// 1 ) Objeto que se va guardar en el contexto

const initialState = {
  CfgConfigId: "",
  ComCompanyId: "",
  ComName: "",
  CfgNavBarColor: "",
  CfgNavLineColor: "",
  CfgNavTextColor: "",
  CfgNavIconColor: "",
  CfgNavIconBG: "",
  CfgLogoBG: "",
  CfgImgBGDesktop: "",
  CfgImgBGMovil: "",
  tokenByEmail: false,
  portalNewEntry: false,
  portalAdministrative: false,
  portalStudent: false,
  portalTeachers: false,
  zerobounce: false,
  zerobounceUrl: "",
  zerobounceApiKey: "",
  idcConfigId: "",
  idcIsActive: false,
  idcProviderCode: "",
  idcProviderName: "",
  idcIdentificationType: "",
};

// 2 ) Logica de manejo de la variable
const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ESTABLECER_COMPANY":
      return {
        ...state,
        CfgConfigId: action.CfgConfigId,
        ComCompanyId: action.ComCompanyId,
        ComName: action.ComName,
        CfgNavBarColor: action.CfgNavBarColor,
        CfgNavLineColor: action.CfgNavLineColor,
        CfgNavTextColor: action.CfgNavTextColor,
        CfgNavIconColor: action.CfgNavIconColor,
        CfgNavIconBG: action.CfgNavIconBG,
        CfgLogoBG: action.CfgLogoBG,
        CfgImgBGDesktop: action.CfgImgBGDesktop,
        CfgImgBGMovil: action.CfgImgBGMovil,
        tokenByEmail: action.tokenByEmail,
        portalNewEntry: action.portalNewEntry,
        portalAdministrative: action.portalAdministrative,
        portalStudent: action.portalStudent,
        portalTeachers: action.portalTeachers,
        zerobounce: action.zerobounce,
        zerobounceUrl: action.zerobounceUrl,
        zerobounceApiKey: action.zerobounceApiKey,
        idcConfigId: action.idcConfigId,
        idcIsActive: action.idcIsActive,
        idcProviderCode: action.idcProviderCode,
        idcProviderName: action.idcProviderName,
        idcIdentificationType: action.idcIdentificationType,
      };
    default:
      return state;
  }
};

//3 se exporta el comporamiento que administra la variable pra poder usarse

export default companyReducer;
